




































































































































































































































































































































































import { Component } from "vue-property-decorator";
import { WorkerWizardModule } from "@/store/modules/workerWizard";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import GiganautVueForm from "@/components/Shared/GiganautVueForm";
import SkillDto from "@/models/Skills/SkillDto";
import QualificationDto from "@/models/Qualifications/QualificationDto";
import PositionDto from "@/models/Positions/PositionDto";
import FieldValidationCodes from "@/lib/fieldValidationCodes";

@Component({
  name: "WorkerWizardAttributes",
  components: {},
})
export default class WorkerWizardAttributes extends GiganautVueForm {
  FieldValidationCodes = FieldValidationCodes;

  // Selected items for deletion
  selectedSkills: any[] = [];
  selectedQualifications: any[] = [];
  selectedPositions: any[] = [];

  // Dialog states
  addSkillsDialog = false;
  addQualificationsDialog = false;
  addPositionsDialog = false;

  // Items to add via dialogs
  skillsToAdd: SkillDto[] = [];
  qualificationsToAdd: QualificationDto[] = [];
  positionsToAdd: PositionDto[] = [];
  positionPayRate = 0;

  skillHeaders = [
    { text: 'Skill', value: 'name', width: '200px' },
    { text: 'Source', value: 'source', width: '150px' },
    { text: 'Gigabot Selection Reason', value: 'agentMatchReason' }
  ];

  qualificationHeaders = [
    { text: 'Qualification', value: 'name', width: '200px' },
    { text: 'Source', value: 'source', width: '150px' },
    { text: 'Gigabot Selection Reason', value: 'agentMatchReason' }
  ];

  get positionHeaders() {
    const headers: any[] = [
      { text: 'Position', value: 'name', width: '200px' },
      { text: 'Source', value: 'source', width: '150px' },
      { text: 'Perm', value: 'isPerm', width: '80px', align: 'center', sortable: false },
      { text: 'Temp', value: 'isTemp', width: '80px', align: 'center', sortable: false },
    ];
    if (this.isTempSelected) {
      headers.push({ text: 'Pay Rate', value: 'payRate', width: '150px' });
    }
    headers.push({ text: 'Verified', value: 'isVerified', width: '80px', align: 'center', sortable: false });
    headers.push({ text: 'Gigabot Selection Reason', value: 'agentMatchReason' });
    return headers;
  }

  get isTempSelected(): boolean {
    return this.worker.workTypes?.includes('Temp') || false;
  }

  get isPermSelected(): boolean {
    return this.worker.workTypes?.includes('Perm') || false;
  }

  async validateForm() {
    // Attributes are optional, so always return false (no validation errors)
    return false;
  }

  get worker() {
    return WorkerWizardModule.newWorker.worker;
  }

  get availableSkills() {
    // Filter out already selected skills
    const selectedIds = (this.worker.matchedSkills || []).map(s => s.attributeId);
    return WorkerDetailsModule.agencyAttributes.skills.filter(
      s => !selectedIds.includes(s.id)
    );
  }

  get availableQualifications() {
    // Filter out already selected qualifications
    const selectedIds = (this.worker.matchedQualifications || []).map(q => q.attributeId);
    return WorkerDetailsModule.agencyAttributes.qualifications.filter(
      q => !selectedIds.includes(q.id)
    );
  }

  get availablePositions() {
    // Filter out already selected positions
    const selectedIds = (this.worker.matchedPositions || []).map(p => p.attributeId);
    return WorkerDetailsModule.agencyAttributes.positions.filter(
      p => !selectedIds.includes(p.id)
    );
  }

  // Dialog openers
  openAddSkillsDialog() {
    this.skillsToAdd = [];
    this.addSkillsDialog = true;
  }

  openAddQualificationsDialog() {
    this.qualificationsToAdd = [];
    this.addQualificationsDialog = true;
  }

  openAddPositionsDialog() {
    this.positionsToAdd = [];
    this.positionPayRate = 0;
    this.addPositionsDialog = true;
  }

  // Multi-add methods
  addMultipleSkills() {
    this.skillsToAdd.forEach(skill => {
      WorkerWizardModule.addManualSkill({
        skillId: skill.id,
        name: skill.name
      });
    });
    this.skillsToAdd = [];
    this.addSkillsDialog = false;
  }

  addMultipleQualifications() {
    this.qualificationsToAdd.forEach(qual => {
      WorkerWizardModule.addManualQualification({
        qualificationId: qual.id,
        name: qual.name
      });
    });
    this.qualificationsToAdd = [];
    this.addQualificationsDialog = false;
  }

  addMultiplePositions() {
    // Validate the form before adding
    if (!(this.$refs.positionsForm as any).validate()) {
      return;
    }

    this.positionsToAdd.forEach(pos => {
      WorkerWizardModule.addManualPosition({
        positionId: pos.id,
        name: pos.name,
        payRate: this.positionPayRate
      });
    });
    this.positionsToAdd = [];
    this.positionPayRate = 0;
    this.addPositionsDialog = false;
  }

  // Multi-delete methods
  deleteSelectedSkills() {
    this.selectedSkills.forEach(skill => {
      WorkerWizardModule.removeSkill(skill.attributeId);
    });
    this.selectedSkills = [];
  }

  deleteSelectedQualifications() {
    this.selectedQualifications.forEach(qual => {
      WorkerWizardModule.removeQualification(qual.attributeId);
    });
    this.selectedQualifications = [];
  }

  deleteSelectedPositions() {
    this.selectedPositions.forEach(pos => {
      WorkerWizardModule.removePosition(pos.attributeId);
    });
    this.selectedPositions = [];
  }

  // Update position work type
  updatePositionWorkType(item: any) {
    // Ensure at least one work type is selected
    if (!item.isTemp && !item.isPerm) {
      // If both are unchecked, default to Temp
      item.isTemp = true;
    }
    // Note: payRate is preserved in memory when temp is toggled off
    // It will be set to 0 when sent to backend (see workerWizard store)
  }

  async mounted() {
    // Load agency attributes if not already loaded
    if (WorkerDetailsModule.agencyAttributes.skills.length === 0) {
      await WorkerDetailsModule.getAgencyAttributes();
    }
  }
}
